<template>
    <table class="uses-tailwind table table-auto w-full">
        <thead class="border-b border-slate-800">
            <tr>
                <th
                    v-if="actions.length > 0"
                    class="px-4 py-2 font-bold min-w-[100px]"
                    v-bind:style="{
                        width: 50 * actions.length + 'px',
                    }"
                >
                    {{ trans('general.actions') }}
                </th>
                <th
                    v-for="column in columns"
                    :key="column.key"
                    class="px-4 py-2 font-bold"
                >
                    {{ column.label }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-if="loading"
                v-for="rowIndex in loadingRows"
                :key="rowIndex"
                class="odd:bg-slate-100"
            >
                <td
                    v-for="columnIndex in columnCount"
                    :key="columnIndex"
                    class="px-4 py-2"
                >
                    <div
                        class="w-full leading-5 animate-pulse"
                        v-bind:class="{
                            'bg-slate-100': rowIndex % 2 === 0,
                            'bg-slate-200': rowIndex % 2 === 1,
                        }"
                    >
                        &nbsp;
                    </div>
                </td>
            </tr>
            <tr
                v-if="!loading && data.length > 0"
                v-for="(row, index) in data"
                :key="index"
                class="odd:bg-slate-100"
            >
                <td class="px-4 py-2">
                    <div class="flex items-center gap-1">
                        <button
                            v-for="action in actions"
                            :key="action.icon"
                            :title="action.title"
                            @click="action.action(row)"
                            class="p-1 bg-transparent hover:bg-slate-200 transition-all"
                        >
                            <i :class="action.icon"></i>
                        </button>
                    </div>
                </td>
                <td
                    v-for="column in columns"
                    :key="column.key"
                    class="px-4 py-2 leading-5"
                >
                    {{ row[column.key] || '/' }}
                </td>
            </tr>
            <tr v-if="!loading && data.length === 0">
                <td
                    v-bind:colspan="columnCount"
                    class="px-4 py-2 leading-5 text-center font-light"
                >
                    {{ trans('general.no_data') }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        columns: {
            type: Array,
            required: true,
            validator: (value) => {
                return (
                    value.length > 0 &&
                    value.every((column) => {
                        return (
                            column.hasOwnProperty('label') &&
                            column.hasOwnProperty('key')
                        );
                    })
                );
            },
        },
        data: {
            type: Array,
            required: true,
            validator: (value) => {
                return value.every((row) => {
                    return typeof row === 'object';
                });
            },
        },
        actions: {
            type: Array,
            required: false,
            default: () => [],
            validator: (value) => {
                return (
                    value.length === 0 ||
                    value.every((action) => {
                        return (
                            action.hasOwnProperty('icon') &&
                            action.hasOwnProperty('action')
                        );
                    })
                );
            },
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loadingRows: 5,
        };
    },
    computed: {
        columnCount() {
            return this.columns.length + (this.actions.length > 0 ? 1 : 0);
        },
    },
    watch: {
        data() {
            this.loadingRows = Math.max(5, this.data.length);
        },
    },
};
</script>
